import ColumnCenter from './ColumnCenter';

export default ColumnCenter;
